// import AppContext from "../../../AppContext";
// import { roleAccesse } from "../../../utils/roleManager";

// const { userData } = useContext(AppContext);
// const userRole = userData?.role;
// roleAccesse(userRole, "brand marketing admin")

/**
 * Determines if a user can enroll another user based on their roles.
 * @param {string} currentUserRole - The role of the current user.
 * @param {string} pendingUserRole - The role of the user to be enrolled.
 * @returns {boolean} - Returns true if the current user can enroll the pending user, otherwise false.
 */

// Define role hierarchy in descending order of power
const roleHierarchy = [
    "account owner",
    //---
    "account admin",
    "account manager",
    "account user",
    //---
    "company account admin",
    "company account manager",
    "company account user",
    //---
    "retail brand account admin",
    "retail brand account manager",
    "retail brand account user",
    //---
    "retail brand marketing admin",
    "retail brand marketing manager",
    "retail brand marketing assistant",

    "store manager",
    "store user"
];

// This function checks if a user can enroll another user based on their roles.
function roleAccesse(currentUserRole, pendingUserRole) {
    if (currentUserRole === "Support") return true;
    if (!currentUserRole) {
        //console.log("CurrentUserRole is required.");
        return false;
    }

    const normalize = str => str?.trim().toLowerCase();

    // Get the indices of the roles in the hierarchy
    const currentUserIndex = roleHierarchy.indexOf(normalize(currentUserRole));
    const pendingUserIndex = roleHierarchy.indexOf(normalize(pendingUserRole));

    // Ensure both roles exist in the hierarchy
    if (currentUserIndex === -1 || pendingUserIndex === -1) {
        console.error("Invalid role provided.");
        return false; // Invalid role provided
    }

    // A user can only enroll another user with a lower role
    return currentUserIndex < pendingUserIndex;
}

function getLowerRoles(currentUserRole) {
    const normalize = str => str?.trim().toLowerCase();
    const currentUserIndex = roleHierarchy.indexOf(normalize(currentUserRole));

    if (currentUserIndex === -1) {
        console.error("Invalid role provided.");
        return [];
    }

    return roleHierarchy.slice(currentUserIndex + 1);
}

export { roleAccesse, getLowerRoles };
